import { CSSProperties } from 'react';

import styled, { css } from 'styled-components';

export const LoadingButtonWrapperStyled = styled.div<{
  customStyle: Pick<CSSProperties, 'color' | 'backgroundColor'>;
}>`
  ${({ customStyle }) => {
    return css`
      button,
      button:hover,
      button:active {
        color: ${customStyle.color} !important;
        background-color: ${customStyle.backgroundColor} !important;
        font-weight: bold;
      }
    `;
  }}
`;
